import styled from "@emotion/styled";




export const HeaderItemWrapper = styled.div`
    height: 100%;
    width: 60%;
    // background-color: grey;
    display: flex;
    align-items: center;
    justify-content: center;
`;